import styled from 'styled-components';
import { Link } from 'react-router-dom';

const TransactionHistoryCardWrapper = styled.div`
  background-color: ${(props) => props.theme.color.neutral.v100};
  border: 1px solid ${(props) => props.theme.color.neutral.v300};
  border-radius: 8px;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  display: flex;
  padding: 24px;
  flex-direction: column;
  margin-right: 16px;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoint.md}px) {
    margin: 0 0 16px 0;
  }
`;

const CardTitle = styled.h1`
  ${(props) => props.theme.font.subhead.v300};
  color: ${(props) => props.theme.color.primary.v400};
  padding: 0 0 20px;
  margin: 0;
  text-transform: uppercase;
`;

const HistoryRow = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 365px;
  margin-bottom: 25px;
`;

const PaymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 30px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 210px;
  }
`;

const commonSubHeaderStyles = styled.h2`
  ${(props) => props.theme.font.heading.v100};
  line-height: 24px;
  color: ${(props) => props.theme.color.primary.v600};
  font-weight: ${(props) => props.theme.font.weight.v300};
  text-transform: uppercase;
  margin: 0;
`;

const PaymentType = styled(commonSubHeaderStyles)`
  margin: 0;
`;

const PaymentAmount = styled(commonSubHeaderStyles)`
  margin: 0;
  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    min-width: 125px;
  }
`;

const PaymentDate = styled.div`
  ${(props) => props.theme.font.body.v100};
  color: ${(props) => props.theme.color.neutral.v500};
`;

const TransactionHistoryLink = styled(Link)`
  text-decoration: underline;
  color: ${(props) => props.theme.color.primary.v200};
  ${(props) => props.theme.font.body.v200};
  display: block;
  margin-top: auto;
  font-size: 14px;
  line-height: 20px;
`;

const NoTransactionsText = styled.p`
  color: ${(props) => props.theme.color.neutral.v500};
  // font-weight: ${(props) => props.theme.font.weight.v100};
  ${(props) => props.theme.font.label.v200};
  margin: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.label.v300};
  }
`;

export {
  TransactionHistoryCardWrapper,
  CardTitle,
  HistoryRow,
  PaymentInfo,
  PaymentType,
  PaymentDate,
  PaymentAmount,
  TransactionHistoryLink,
  NoTransactionsText,
};
